import React, {PureComponent} from 'react';
import TranslatedText from '../../atoms/TranslatedText';
import Apng from '../../atoms/Apng';

import './HdoSlides.css';

export default class HdoSlideTwo extends PureComponent {
    render() {
        const {data, title} = this.props;
        const style = {backgroundImage: `url(${data.bg})`};

        return (
            <div className="HdoSlideTwo HdoSlide" style={style}>
                <div className="HdoSlide-top">
                    <h3 className="top-title">
                        <TranslatedText tag={title} />
                    </h3>
                </div>
                <div className="HdoSlide-center HdoSlideTwo-center">
                    <div className="HdoSlide-label HdoSlideTwo-label">
                        <TranslatedText tag={data.label} />
                    </div>
                    <Apng
                        className="HdoSlideTwo-img"
                        src={data.img}
                        alt=""
                        draggable="false"
                    />
                    <div className="HdoSlideTwo-bottomLabel HdoSlide-bottomLabel">
                        <TranslatedText tag={data.labelHDO} />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/highDefinitionOptics/HdoSlideTwo.js